const useDevice = () => ({
  isDesktop:
    !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|SamsungBrowser/i.test(
      navigator.userAgent.toLowerCase(),
    ) && !/Tablet|iPad/i.test(navigator.userAgent.toLowerCase()),
  isMobile: /android|webos|iphone|ipod|blackberry|iemobile|opera mini|SamsungBrowser/i.test(
    navigator.userAgent.toLowerCase(),
  ),
  isTablet: /Tablet|iPad/i.test(navigator.userAgent.toLowerCase()),
  isAndroid: /android/i.test(navigator.userAgent.toLowerCase()),
  isIOS: /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
  windowsPlatforms: /win32|win64|windows|wince/i.test(navigator.userAgent.toLowerCase()),
});

export default useDevice;
